import { Modal, Button } from 'flowbite-react';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { useUserContext } from 'src/context/UserProvider';
import { useSearchParams } from 'react-router-dom';

const ShowCannotLinkLMSAccountModal = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { showCantLinkLMSProfileModal, setShowCantLinkLMSProfileModal, studentCode } = useUserContext();

	const onClose = () => {
		searchParams.delete('lms-token');
		setSearchParams(searchParams);
		setShowCantLinkLMSProfileModal(false);
	};

	return (
		<div>
			<Modal position={'center'} dismissible={true} size={'md'} show={showCantLinkLMSProfileModal} onClose={onClose}>
				<Modal.Body className="relative flex flex-col gap-y-8 justify-center rounded-[8px] border border-solid border-[#555770] dark:bg-[#1F2A37] p-8">
					<div>
						<h6 className="font-inter text-[20px] font-[600] leading-[120%]">Cannnot link your LMS account</h6>
						<p className="mt-[16px] font-inter text-[16px] font-[400] leading-[24px]">
							We cannot link your LMS <span className="text-[#7777E7]">{studentCode}</span> profile to this LevelUp
							account as it is already linked to another account. Please contact the admin for further assistance.
						</p>
						{/* <p className="mt-[16px] font-inter text-[16px] font-[400] leading-[24px]">
							To confirm deletion, type “DELETE” below:
						</p>
						<input
							className="mt-[16px] w-[100%] rounded-[8px] dark:bg-[#374151] border border-[#EBEBF0] dark:border-[#4B5563] "
							type="text"
							placeholder={'type DELETE here...'}
							value={deleteInputValue}
							onChange={e => setDeleteInputValue(e.target.value)}
						/> */}
						<div className="mt-[16px] flex items-center gap-[16px] justify-center">
							<Button
								color="purplePlaced"
								onClick={() => {
									onClose();
								}}
							>
								Okay
							</Button>
						</div>
					</div>
					<RxCross2
						onClick={onClose}
						className="absolute right-[10px] top-[10px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
					/>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default ShowCannotLinkLMSAccountModal;
